<template>
  <div class="pu-page">

    <!-- Hero -->
    <div class="pu-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-account-convert-outline</v-icon>
        </v-avatar>
        <div>
          <div class="pu-hero__title">Asignar Cargos y Sedes</div>
          <div class="pu-hero__sub" v-if="persona.nombres">
            {{ persona.nombres }} {{ persona.pri_apellido }}
            <span v-if="persona.num_doc" style="opacity:0.7;"> — CI: {{ persona.num_doc }}</span>
          </div>
        </div>
      </div>
      <v-btn small dark text @click="$router.push('personas')">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <div class="pu-body">

      <Alertas ref="alertar" />

      <v-card outlined class="pu-card mb-4" v-if="!cargando">
        <v-card-title class="pu-section-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-badge-account-outline</v-icon>
          Cargos y Sedes
        </v-card-title>
        <v-card-text class="pt-3 pb-2 px-4">
          <Asignar ref="refAsignar" v-show="!cargando" :model="cargos" :default="carguitos" :toasig="asig" />
        </v-card-text>
      </v-card>

      <v-card outlined class="pu-card">
        <v-card-title class="pu-section-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-account-plus-outline</v-icon>
          Crear Usuario
        </v-card-title>
        <v-card-text class="pt-3 pb-2 px-4">
          <ToNewUserPerson v-show="ver_us" :persona="persona"
            :title="'En caso de error, se debe crear el usuario primeramente'" />
        </v-card-text>
      </v-card>

    </div>

    <notifications group="auth"  position="bottom right" />
    <notifications group="auth4" position="bottom right" />
    <notifications group="auth2" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
  </div>
</template>

<script>
import Asignar from '@/components/AAsignarCargo.vue';
import ToNewUserPerson from '@/components/ToNewUserPerson.vue';
import Alertas from '@/components/AAlertas.vue';
import { parseJsonError } from '@/components/Utils.js';
import gql from 'graphql-tag';

export default {
  components: { Asignar, ToNewUserPerson, Alertas },
  data() {
    return {
      cargos: [],
      carguitos: [],
      persona: {},
      cargando: true,
      ver_us: true,
      asig: { asignados: [] },
    };
  },
  watch: {
    'asig.asignados': function() {
      if (this.asig.asignados.length > 0) {
        if (!this.persona.usuario) this.ver_us = true;
        this.persona.asignados = this.asig.asignados[0];
      } else {
        this.ver_us = true;
      }
    },
  },
  methods: {
    async getDatos(id) {
      this.$refs.alertar.cargando();
      var vue = this;
      var sql = gql`
        query{
          getPersona(id:${id}){
            id
            num_doc,nombres,pri_apellido,seg_apellido,
            usuario{cargos{cargo{id,nombre},sede{id,nombre},desde}}
          }
        }
      `;
      this.$apollo.mutate({ mutation: sql })
        .then((data) => {
          var persona = data.data.getPersona;
          this.$refs.alertar.reset();
          this.cargando = false;
          if (!persona) return;
          this.persona = persona;
          if (!persona.usuario) return;
          var cc = [];
          persona.usuario.cargos.forEach(function(e) {
            cc.push({ idcargo: { id: e.cargo.id, nombre: e.cargo.nombre }, idsede: { id: e.sede.id, nombre: e.sede.nombre }, desde: e.desde });
          });
          this.carguitos = cc;

          this.$nextTick(() => this.$refs.refAsignar.cargar() );
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          vue.$notify(parseJsonError(error));
        });
    },
  },
  mounted() {
    var est = JSON.parse(sessionStorage.getItem('xestudiante'));
    this.getDatos(est.id);
  },
};
</script>

<style scoped>
.pu-page { min-height: 100vh; background: #f5f7fa; }

.pu-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pu-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pu-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pu-body { padding: 20px 24px; }

.pu-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.pu-section-title {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #283593;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e8edf7;
}
</style>
